export default "__VITE_PUBLIC_ASSET__b6f0b398__"